import { createContext } from 'react';
export type BookingEngineTrackingContextType =
  | Readonly<{
      reference_id: string;
      days_before_departure: number;
      departure_date_range: string;
      departure_quarter: number;
      departure_semester: number;
      resort_name: string;
      resort_code: string;
      resort_country: string;
      resort_season_type: void | string;
      resort_region: void | string;
      resort_exclusive_collection: string | null | undefined;
      resort_type: string;
      resort_adult: number;
      resort_children: number;
      resort_departure_city_name: string;
      resort_departure_date: string;
      resort_checkout_date: string;
      resort_night_number: number;
      resort_participants: number;
      resort_transport: string;
      resort_year_season: string;
      room_type: void | string;
    }>
  | null
  | undefined;
export const BookingEngineTrackingContext =
  createContext<BookingEngineTrackingContextType>(undefined);
